import { render, staticRenderFns } from "./OnboardingVouchersSettings.vue?vue&type=template&id=39cd9d2c&scoped=true"
import script from "./OnboardingVouchersSettings.vue?vue&type=script&lang=js"
export * from "./OnboardingVouchersSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd9d2c",
  null
  
)

export default component.exports